import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { STATUS_META, SEVERITY_META } from "./statusColors";

export const StatusChip = ({ status, withTooltip = true, size = "small", sx = {} }) => {
  const meta = STATUS_META[status] || {
    label: status || "Unknown",
    bg: "#eeeeee",
    fg: "#616161",
    description: "Unknown status.",
  };
  const chip = (
    <Chip
      size={size}
      label={meta.label}
      sx={{
        backgroundColor: meta.bg,
        color: meta.fg,
        fontWeight: 600,
        fontSize: size === "small" ? 11 : 13,
        height: size === "small" ? 22 : 28,
        ...sx,
      }}
    />
  );
  if (!withTooltip) return chip;
  return (
    <Tooltip title={meta.description} arrow>
      <span>{chip}</span>
    </Tooltip>
  );
};

export const SeverityChip = ({ severity, size = "small", sx = {} }) => {
  const s = (severity || "").toUpperCase();
  const meta = SEVERITY_META[s] || { bg: "#eeeeee", fg: "#616161" };
  return (
    <Chip
      size={size}
      label={s || "—"}
      sx={{
        backgroundColor: meta.bg,
        color: meta.fg,
        fontWeight: 600,
        fontSize: size === "small" ? 11 : 13,
        height: size === "small" ? 22 : 28,
        ...sx,
      }}
    />
  );
};

export default StatusChip;
